export default __webpack_public_path__ + "static/media/avatar-s-4.a649af23.jpg";